const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1165"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5223",
    d: "M34.125 42H7.875A7.875 7.875 0 0 1 0 34.125V7.875A7.875 7.875 0 0 1 7.875 0h26.25A7.875 7.875 0 0 1 42 7.875v26.25A7.875 7.875 0 0 1 34.125 42zm0 0",
    transform: "translate(.5 .5)",
    style: {
      fill: "#f9f9f9",
      stroke: "#ececec"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1166"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5259",
    d: "M16.526 2.128H5.768a1.6 1.6 0 0 0-1.621 1.62v1.3H1.62A1.6 1.6 0 0 0 0 6.665v13.868a1.6 1.6 0 0 0 1.62 1.621h13.869a1.605 1.605 0 0 0 1.62-1.621v-1.3h2.527a1.605 1.605 0 0 0 1.62-1.621V6.6zM6.935 17.293a.626.626 0 0 1-.907 0 .626.626 0 0 1 0-.907l4.342-4.343H7.778a.648.648 0 1 1 0-1.3h4.148a.388.388 0 0 1 .259.065.784.784 0 0 1 .324.324.389.389 0 0 1 .065.259v4.147a.65.65 0 0 1-.648.648.7.7 0 0 1-.647-.648v-2.587zm9.85-13.943 3.122 2.991h-1.76a1.369 1.369 0 0 1-1.362-1.361zM15.7 20.223a.511.511 0 0 1-.519.518H1.96a.511.511 0 0 1-.518-.518V6.953a.511.511 0 0 1 .518-.518h2.123l.065 11.182a1.6 1.6 0 0 0 1.621 1.62h9.995l-.065.986z",
    transform: "translate(10.326 9.182)",
    style: {
      fill: "#faa100"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTab);
export default __webpack_public_path__ + "static/media/new-tab.5c32bd1ffde8907ffc871682c5c34aad.svg";
export { ForwardRef as ReactComponent };